import { render, staticRenderFns } from "./WarningSign.vue?vue&type=template&id=664c24e5"
import script from "./WarningSign.vue?vue&type=script&lang=js"
export * from "./WarningSign.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports